import OneOnOneNotesApi from "apis/one-on-one-notes.api";
import { OneOnOneNotesResponse } from "responses";
import { PaginationQuery } from "types/feedback-request";

const OneOnOneNotesService = {
  getNotesForUser: async (
    userId: number,
    query: PaginationQuery,
  ): Promise<OneOnOneNotesResponse[]> => {
    return OneOnOneNotesApi.getNotesForUser(userId, query);
  },
};

export default OneOnOneNotesService;
